import { getTag } from './get-tag';

export function whiteLabel() {
  const tag = getTag();

  return tag
    ? {
        cer_padre: {
          whitelabel: {
            configurazione: { referral: { _eq: tag } },
          },
        },
      }
    : {};
}
